module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workingarea"
  }, [_c('div', {
    staticClass: "room room_width_objects",
    class: [{
        top: _vm.isAlignedTop
      },
      {
        'no-end-line': !_vm.hasEndline
      },
      {
        'display-block': _vm.display === 'block'
      },
      {
        'k2_prolunghe': _vm.room_size.height > _vm.heights.xl && _vm.configurator === 'k2' && _vm.$store.state.view === 'uprights'
      }
    ],
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "room_height_line",
    style: (_vm.line_height_style)
  }, [_c('span', {
    staticClass: "medium h8 upcase",
    class: [_vm.compBgLineText]
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.round(_vm.currentHeight)) + " CM\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "room_width_line",
    style: (_vm.line_width_style)
  }, [_c('span', {
    staticClass: "medium h8 upcase",
    class: [_vm.compBgLineText]
  }, [_vm._v(_vm._s(_vm.round(_vm.currentWidth)) + " CM")])]), _vm._v(" "), (_vm.hasEndline) ? _c('span', {
    staticClass: "room_size_width h8 regular upcase"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.round(_vm.room_size.width)) + " cm\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.hasEndline) ? _c('span', {
    staticClass: "room_size_height h8 regular upcase"
  }, [(_vm.configurator === 'k2' && _vm.room_size.height > _vm.heights.xl) ? _c('img', {
    attrs: {
      "src": "/images/Greaterthan.svg"
    }
  }) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(_vm.round(_vm.getRoomHeight())) + " cm\n\t\t")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f663bb0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/Room.vue
// module id = 668
// module chunks = 0